import React from "react";
import camera from "../../assets/icons/cam.svg";
import { toast } from "react-toastify";
import {
  getImageDimensions,
  ImageSizeAndDimensionChecker,
  toastMessage,
} from "../../utils/utils";
type NoImageUploaderProps = {
  height?: string;
  clickHereRef: string;
  title?: string;
  uploadApi: any;
  id: any;
  dimension: any;
};
const NoImageUploader = ({
  height,
  clickHereRef,
  title,
  uploadApi,
  id,
  dimension,
}: NoImageUploaderProps) => {
  return (
    <>
      <label htmlFor={clickHereRef}>
        <div
          className={` ${`border-primary border-dotted border-2 ${
            height ? height : ""
          } h-[180px] bg-[#F3F3F3]`} flex flex-col py-4 justify-center items-center   rounded-lg  gap-5`}
        >
          <>
            <img loading="lazy" src={camera} alt="camera" className="w-[43px]" />
            <div className=" text-center  text-sm ">
              <>
                <input
                  type="file"
                  accept={"image/*"}
                  hidden
                  id={clickHereRef}
                  onChange={async (e) => {
                    //@ts-ignore
                    const file = e.target.files[0];
                    if (file) {
                      const { width, height } = await getImageDimensions(file);
                      if (
                        !ImageSizeAndDimensionChecker(
                          width,
                          height,
                          dimension[0],
                          dimension[1],
                          file.size
                        )
                      ) {
                        e.target.value = "";
                        return;
                      }
                      const reader = new FileReader();
                      reader.onloadend = async () => {
                        const image = reader?.result
                          ?.toString()
                          .replace(/^data:image\/[a-zA-Z]+;base64,/, "");
                        await toast.promise(
                          uploadApi({ data: { image: image }, id: id }),
                          toastMessage()
                        );
                        //@ts-ignore
                      };
                      reader.readAsDataURL(file);
                    }
                  }}
                />

                <p className="font-bold text-sm">
                  Click
                  <span className="text-red-500 mx-1 cursor-pointer">HERE</span>
                  to {title ? title : "uplaod image"}
                </p>

                <p className="block text-xs mt-4  ">
                  {dimension[0]} x {dimension[1]} Px, PNG, JPG,
                </p>
              </>
            </div>
          </>
        </div>
      </label>
    </>
  );
};

export default NoImageUploader;
